import Crud from '../views/Landmark/Crud'
import Entity from '../views/Landmark/Add'

let routes = {
    path: '/users',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/landmarks/add',
            name: 'NewLandmark',
            component: Entity,
            meta: {
                ability: 'pontos_referencia.gerenciar',
                pageTitle: 'Landmark',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/landmarks',
                    },
                    {
                        text: 'Add',
                        active: true,

                    },
                ],
            },
        },
        {
            path: '/landmarks/edit/:id?',
            name: 'EditLandmark',
            component: Entity,
            meta: {
                ability: 'pontos_referencia.gerenciar',
                pageTitle: 'Landmark',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/landmarks',
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/landmarks',
            name: 'list-landmarks',
            component: Crud,
            meta: {
                ability: 'pontos_referencia.ver',
                pageTitle: 'Landmarks',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
